var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackspace = function SvgBackspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "backspace_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#backspace_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 19a2 2 0 0 1-.937-.225 1.9 1.9 0 0 1-.713-.625l-3.525-5A1.94 1.94 0 0 1 3.45 12q0-.625.375-1.15l3.525-5q.274-.4.713-.625A2 2 0 0 1 9 5h10q.824 0 1.413.588Q21 6.175 21 7v10q0 .824-.587 1.413A1.93 1.93 0 0 1 19 19zm0-2h10V7H9l-3.55 5zm5-3.6 1.9 1.9a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7L15.4 12l1.9-1.9a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275L14 10.6l-1.9-1.9a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7l1.9 1.9-1.9 1.9a.95.95 0 0 0-.275.7q0 .425.275.7a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275z"
  }))));
};
export default SvgBackspace;